import { render, staticRenderFns } from "./PaSettingAdd.vue?vue&type=template&id=88512d72&scoped=true"
import script from "./PaSettingAdd.vue?vue&type=script&lang=js"
export * from "./PaSettingAdd.vue?vue&type=script&lang=js"
import style0 from "./PaSettingAdd.vue?vue&type=style&index=0&id=88512d72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88512d72",
  null
  
)

export default component.exports